import {
  SET_CALENDAR_FOUND,
  SET_CALENDAR_MANAGEMENT,
  SET_CREDENTIALS_KEY,
  SET_USER_INFO,
  UPDATE_APPOINTMENT_TYPES,
  UPDATE_CALENDAR_INFO,
  UPDATE_OPEN_APPOINTMENT_TYPES,
  UPDATE_SCHEDULING_WINDOWS,
  UPDATE_IS_SAME_AS_OPENING_HOURS,
  UPDATE_APPOINTMENT_TYPE_ERRORS,
} from "../actions/CalendarManagementActions";

const initialState = {
  userInfo: {},
  calendarFound: false,

  calendarInfo: {},
  updatedCalendarInfo: {},
  previousCalendarInfo: {},

  schedulingWindows: [],
  updatedSchedulingWindows: [],
  isSameAsOpeningHours: true,
  updatedIsSameAsOpeningHours: true,

  appointmentTypes: [],
  updatedAppointmentTypes: [],

  appointmentTypeErrors: [],

  openAppointmentTypes: [],

  credentialsKey: "default",

  config: {
    minAppointmentTypesListSize: 0,
    maxAppointmentTypesListSize: 10,
    minAppointmentTypeCharacters: 3,
    maxAppointmentTypeCharacters: 100,
    minAppointmentDescriptionCharacters: 3,
    maxAppointmentDescriptionCharacters: 1000,
    minAppointmentPostSchedulingTextMessageCharacters: 0,
    maxAppointmentPostSchedulingTextMessageCharacters: 200,
    minSchedulingWindowsRows: 1,
    maxSchedulingWindowsRows: 7,
    minHoursOptionsRows: 1,
    maxHoursOptionsRows: 3,
  },
};

const calendarManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CALENDAR_MANAGEMENT:
      return {
        ...state,
        calendarInfo: { ...action.payload.calendarInfo },
        updatedCalendarInfo: { ...action.payload.calendarInfo },
        previousCalendarInfo: { ...action.payload.calendarInfo },

        schedulingWindows: action.payload.schedulingWindows ? [...action.payload.schedulingWindows] : [],
        updatedSchedulingWindows: action.payload.schedulingWindows ? [...action.payload.schedulingWindows] : [],
        isSameAsOpeningHours:
          action.payload.isSameAsOpeningHours === undefined ? true : action.payload.isSameAsOpeningHours,
        updatedIsSameAsOpeningHours:
          action.payload.isSameAsOpeningHours === undefined ? true : action.payload.isSameAsOpeningHours,

        appointmentTypes: action.payload.appointmentTypes ? [...action.payload.appointmentTypes] : [],
        updatedAppointmentTypes: action.payload.appointmentTypes ? [...action.payload.appointmentTypes] : [],

        config: { ...state.config, ...(action.payload.config || {}) },
      };

    case SET_USER_INFO:
      return {
        ...state,
        userInfo: { ...action.payload },
      };
    case SET_CALENDAR_FOUND:
      return {
        ...state,
        calendarFound: action.payload,
      };
    case SET_CREDENTIALS_KEY:
      return {
        ...state,
        credentialsKey: action.payload,
      };
    case UPDATE_CALENDAR_INFO:
      return {
        ...state,
        updatedCalendarInfo: { ...action.payload },
        previousCalendarInfo: { ...state.updatedCalendarInfo },
      };
    case UPDATE_SCHEDULING_WINDOWS:
      return {
        ...state,
        updatedSchedulingWindows: [...action.payload],
      };
    case UPDATE_IS_SAME_AS_OPENING_HOURS:
      return {
        ...state,
        updatedIsSameAsOpeningHours: action.payload,
      };
    case UPDATE_APPOINTMENT_TYPES:
      return {
        ...state,
        updatedAppointmentTypes: [...action.payload],
      };
    case UPDATE_OPEN_APPOINTMENT_TYPES:
      return {
        ...state,
        openAppointmentTypes: [...action.payload],
      };
    case UPDATE_APPOINTMENT_TYPE_ERRORS:
      return {
        ...state,
        appointmentTypeErrors: [...action.payload],
      };
    case "CANCEL": {
      return {
        ...state,
        updatedCalendarInfo: JSON.parse(JSON.stringify(state.calendarInfo)), // Deep copy
        updatedSchedulingWindows: JSON.parse(JSON.stringify(state.schedulingWindows)), // Deep copy
        updatedAppointmentTypes: JSON.parse(JSON.stringify(state.appointmentTypes)), // Deep copy
        openAppointmentTypes: [],
        appointmentTypeErrors: [],
      };
    }
    case "SAVED": {
      return {
        ...state,
        calendarFound: true,
        calendarInfo: JSON.parse(JSON.stringify(state.updatedCalendarInfo)), // Deep copy
        schedulingWindows: JSON.parse(JSON.stringify(state.updatedSchedulingWindows)), // Deep copy
        appointmentTypes: JSON.parse(JSON.stringify(state.updatedAppointmentTypes)), // Deep copy
        openAppointmentTypes: [],
        appointmentTypeErrors: [],
      };
    }

    default:
      return state;
  }
};

export default calendarManagementReducer;
